import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  size?: 'md' | 'lg';
  href?: string;
  onClick?: (e?: React.MouseEvent) => void;
  className?: string;
  type?: 'button' | 'submit';
  external?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  href,
  onClick,
  className = '',
  type = 'button',
  external = false
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-semibold rounded-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variantStyles = {
    primary: 'bg-orange text-white hover:bg-orange/90 focus:ring-orange',
    secondary: 'border-2 border-navy text-navy hover:bg-navy hover:text-white focus:ring-navy'
  };
  const sizeStyles = {
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  const classes = `${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${className}`;
  if (href) {
    return <a href={href} className={classes} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined} onClick={onClick ? e => {
      e.preventDefault();
      onClick(e);
    } : undefined} data-id="element-213">
        {children}
      </a>;
  }
  return <button type={type} onClick={onClick} className={classes} data-id="element-214">
      {children}
    </button>;
}